if not App.angularApp?
    return

App.angularApp.directive 'mfClearInvalidSelection', ['$parse', ($parse) ->
    return {
        restrict: 'A'
        require: 'uiSelect'
        link: (scope, element, attrs) =>
            # we can't just watch $select.items because that breaks filtering
            repeat_attr = $(element.find('.ui-select-choices')[0]).attr('repeat')
            [junk, array_name] = repeat_attr.match(/\s+in\s+(\S+)/)

            prop = attrs.mfClearInvalidSelection

            if attrs.dontClearIf
                dontClearFn = $parse(attrs.dontClearIf)

            if prop?
                scope.$parent.$watchCollection array_name, (items) ->
                    # Make sure it's ok to clear it. If not, don't touch it.
                    if dontClearFn?(scope.$parent)
                        return

                    selected = scope.$select.selected?[prop]
                    match = _.filter(items, (item) -> item[prop] is selected)[0]
                    # If match isn't set, clear the selection. If match is set,
                    # but it's not the same object, then we want to use match.
                    # (The original may no longer be an option.) If it's the
                    # same object, we don't need to do anything.
                    if not match? or match isnt scope.$select.selected
                        scope.$select.select(match ? null)

            else
                scope.$parent.$watchCollection array_name, (items) ->
                    if dontClearFn?(scope.$parent)
                        return
                    if scope.$select.selected not in items
                        scope.$select.select(null)
    }
]
